module.exports = {
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST: 'RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST',
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS: 'RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS',
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_FAILURE: 'RETRIEVE_OUTBOUND_POSTAL_OPERATOR_UNLOCODE_FAILURE',
  DEPARTURE_UNLOCODE_CHECKED: 'DEPARTURE_UNLOCODE_CHECKED',
  DEPARTURE_POSTAL_OPERATOR_EXPANDED: 'DEPARTURE_POSTAL_OPERATOR_EXPANDED',
  SELECT_ALL_DEPARTURE_UNLOCODES: 'SELECT_ALL_DEPARTURE_UNLOCODES',
  DESELECT_ALL_DEPARTURE_UNLOCODES: 'DESELECT_ALL_DEPARTURE_UNLOCODES',
  DEPARTURE_POSTAL_OPERATOR_EXPANDED_UNLOCODE_ADMIN: 'DEPARTURE_POSTAL_OPERATOR_EXPANDED_UNLOCODE_ADMIN',
};
